import { terms } from '../../language/terms';
import {
  CERT_TYPE_AS2208_LABEL,
  CERT_TYPE_AS4666_LABEL,
} from '../../modules/glass-accreditation/utils/certificate-utils';

/** "CertificateAnnualReview" -> "Certificate Annual Review": the code, read as words. */
function spaceOutCode(code: string): string {
  return code.replace(/([a-z])([A-Z])/g, '$1 $2');
}

/**
 * The email types whose code names a domain concept, read through its term (#398 C16d, the SA's
 * token list E). Every other type reads as its code spaced out.
 */
const EMAIL_TYPE_LABELS: Readonly<Record<string, string>> = {
  UserInvitation: `${terms.loginUser.value} Invitation`,
};

/** One word for an email type, in the filter and on each row's badge alike. */
export function emailTypeLabel(code: string): string {
  return EMAIL_TYPE_LABELS[code] ?? spaceOutCode(code);
}

/**
 * The sending modules as a person names them, in the filter and in each row alike. The two
 * certificate modules keep the glossary's own words for their types; Auth.Users and
 * GlassAccreditation are named by their terms (#398 C16d, the SA's token list E). A module not
 * listed reads as its code.
 */
const SOURCE_MODULE_LABELS: Readonly<Record<string, string>> = {
  'Certificates.AS2208': `${CERT_TYPE_AS2208_LABEL} Certificates`,
  'Certificates.AS4666': `${CERT_TYPE_AS4666_LABEL} Certificates`,
  'Auth.Users': terms.loginUser.plural,
  'GlassAccreditation': terms.glassAccreditation.value,
};

export function sourceModuleLabel(code: string): string {
  return SOURCE_MODULE_LABELS[code] ?? code;
}
